module.exports = __webpack_public_path__ + "static/search3-fa51d953d75ecc42c3a9a55347b81438.png";